export default __webpack_public_path__ + "static/media/hospital-management-system-pic-1.90002894.png";